import create from './libs/core';
import modules from './modules';

// libs

// components
import './components/BrowserDetection';
import './components/CheckDevice';
import './components/ConvertSvg';
import './components/LazyLoadImage'
import './components/UserAgent';
import './components/AnimationScrollPage'
import './components/ParallaxImages'
import './components/FloatScrollParallax'
import './components/BgVideoOptions'
import './components/header/Header'
import './components/header/Menu'
import './components/Popup'
import './components/SelectC8'
import './components/VideoInline'
import './components/WebGLBackground'

// import js of custom blocks
import.meta.glob('../../../../blocks/*/assets/script.js', {
  eager: true
})

import.meta.glob('../../../../blocks/*/appearances/*/assets/script.js', {
  eager: true
})

// import js of partials
import.meta.glob('../../../../partials/*/assets/script.js', {
  eager: true
})

import './components/header/ADAMenu'
import './components/ADA'

document.addEventListener(
  'DOMContentLoaded',
  async () => {
    create(modules);
  },
  false,
);

// Hot reload for start dev.
if (import.meta.hot) {
  console.log('Updated vite');
}